module.exports = __webpack_public_path__ + "img/Inlays&Onlays.22452045.jpg";